const plannerAreaList = [
  {
    order: 1,
    databaseId: "26sMCDaXkPFTVWtRzlYT",
    id: "logistic",
    type: "logistic",
    typeName: "Logistics Building",
    color: "#708188",
    display: true,
  },
  {
    order: 2,
    databaseId: "4FOQpcI2Ae1Qol0r1acL",
    id: "infrastructure",
    type: "infrastructure",
    typeName: "Infrastructure Building",
    color: "#866262",
    display: false,
  },
  {
    order: 3,
    databaseId: "mCh3SLKwAbHdwcC9DO7i",
    id: "warehouse",
    type: "warehouse",
    typeName: "Warehouse",
    color: "#929BBA",
    display: true,
  },
  {
    order: 4,
    databaseId: "VBCE79LvQ9G4TWpZ5nht",
    id: "highbay",
    type: "highbay",
    typeName: "High Bay Warehouse",
    color: "#929BBA",
    display: false,
  },
  {
    order: 5,
    databaseId: "nYSWjjTJKzw65K0NvuKM",
    id: "office",
    type: "office",
    typeName: "Office Building",
    color: "#D7BEA0",
    display: true,
  },
  {
    order: 6,
    databaseId: "uWUeRJCf8fcDBrvDU1ce",
    id: "production",
    type: "production",
    typeName: "Production Building",
    color: "#BAAB4C",
    display: true,
  },
  {
    order: 7,
    databaseId: "OZZcIUTclOqhra60YiZ0",
    id: "carparking",
    type: "carparking",
    typeName: "Car Parking Area",
    color: "#9F9694",
    display: false,
  },
  {
    order: 8,
    databaseId: "U5UD4FFxaS1V7JEIEGms",
    id: "truckparking",
    type: "truckparking",
    typeName: "Truck Parking Area",
    color: "#6d6c6b" /* "#7b7472" */,
    display: false,
  },
];

const plannerAreaObject = {
  "26sMCDaXkPFTVWtRzlYT": {
    order: 1,
    databaseId: "26sMCDaXkPFTVWtRzlYT",
    id: "logistic",
    type: "logistic",
    typeName: "Logistics Building",
    color: "#708188",
    display: true,
  },
  "4FOQpcI2Ae1Qol0r1acL": {
    order: 2,
    databaseId: "4FOQpcI2Ae1Qol0r1acL",
    id: "infrastructure",
    type: "infrastructure",
    typeName: "Infrastructure Building",
    color: "#866262",
    display: false,
  },
  "mCh3SLKwAbHdwcC9DO7i": {
    order: 3,
    databaseId: "mCh3SLKwAbHdwcC9DO7i",
    id: "warehouse",
    type: "warehouse",
    typeName: "Warehouse",
    color: "#929BBA",
    display: true,
  },
  "VBCE79LvQ9G4TWpZ5nht": {
    order: 4,
    databaseId: "VBCE79LvQ9G4TWpZ5nht",
    id: "highbay",
    type: "highbay",
    typeName: "High Bay Warehouse",
    color: "#929BBA",
    display: false,
  },
  "nYSWjjTJKzw65K0NvuKM": {
    order: 5,
    databaseId: "nYSWjjTJKzw65K0NvuKM",
    id: "office",
    type: "office",
    typeName: "Office Building",
    color: "#D7BEA0",
    display: true,
  },
  "uWUeRJCf8fcDBrvDU1ce": {
    order: 6,
    databaseId: "uWUeRJCf8fcDBrvDU1ce",
    id: "production",
    type: "production",
    typeName: "Production Building",
    color: "#BAAB4C",
    display: true,
  },
  "OZZcIUTclOqhra60YiZ0": {
    order: 7,
    databaseId: "OZZcIUTclOqhra60YiZ0",
    id: "carparking",
    type: "carparking",
    typeName: "Car Parking Area",
    color: "#9F9694",
    display: true,
  },
  "U5UD4FFxaS1V7JEIEGms": {
    order: 8,
    databaseId: "U5UD4FFxaS1V7JEIEGms",
    id: "truckparking",
    type: "truckparking",
    typeName: "Truck Parking Area",
    color: "#9F9694",
    display: false,
  },
  "S6HDr1mORtOkdxh8bnsf": {
    order: 9,
    databaseId: "S6HDr1mORtOkdxh8bnsf",
    id: "dockingArea",
    type: "dockingArea",
    typeName: "Docking Area",
    color: "#6d6c6b",
    display: false,
  },
};

export const plannerInputsAll = {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    stories: 1,
    isolated: false,
    cost: -1,
    numEmployees: -1,
    numDocks: -1,
    numParkingSlots: -1,
    prediction: false,
    truckRequirement: -1,
}

export const plannerAreaInputs = {
  logistic: {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    numDocks: -1,
    truckRequirement: -1,
    isolated: false,
    cost: -1,
  },
  infrastructure: {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    isolated: false,
    cost: -1,
  },
  warehouse: {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    numDocks: -1,
    truckRequirement: -1,
    isolated: false,
    cost: -1,
  },
  highbay: {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    numDocks: -1,
    truckRequirement: -1,
    isolated: false,
    cost: -1,
  },
  office: {
    rangeMin: -1,
    rangeMax: -1,
    stories: 1,
    cost: -1,
    isolated: false,
  },
  production: {
    rangeMin: -1,
    rangeMax: -1,
    height: -1,
    numDocks: -1,
    truckRequirement: -1,
    isolated: false,
    cost: -1,
  },
  carparking: {
    rangeMax: -1,
    numParkingSlots: -1,
    cost: -1,
    isolated: true,
  },
  truckparking: {
    numParkingSlots: -1,
    truckRequirement: -1,
    cost: -1,
  },
};
